module.exports = __webpack_public_path__ + "images/bookmark-blue.fe6c7b926fb2cf620a56aec1833ba5a1.svg";